import { useQuery } from "@tanstack/react-query";
import { useLoginUser } from "@/hooks/useAuth";
import {
  fetchWantedOverview,
  wantedOverviewKeys,
} from "@/services/wanted/overview";

export function useWantedOverviewQuery({
  year,
  month,
  groupId,
}: {
  readonly year: number;
  readonly month: number;
  readonly groupId: string;
}) {
  const user = useLoginUser();
  return useQuery({
    queryKey: wantedOverviewKeys.query(user, { year, month }, groupId),
    queryFn: ({ signal }) =>
      fetchWantedOverview({ year, month, groupId, signal }),
    enabled: !!user && !!groupId && year > 0 && month > 0,
    placeholderData: undefined,
  });
}
